import React, { useState, useEffect } from 'react'

import './MyTooltip.css'
import { VictoryTooltip, VictoryPortal } from 'victory'


const MyTooltip = (data) => {

  const {x, y, text, active} = data
  return (
    <VictoryPortal>
      <g style={{pointerEvents: "none", display: active ? "block":"none" }}>
        <foreignObject x={x - 40} y={y - 40}  width="120" height="400" >
          <div className='my-tooltip'>
            <div dangerouslySetInnerHTML={{__html: text}} />
          </div>
        </foreignObject>
      </g>
    </VictoryPortal>
    )

}


MyTooltip.defaultEvents = VictoryTooltip.defaultEvents;

export default MyTooltip;
